import { FETCH_STATES } from '../constants/fetchStates';

export const types = {
  GET_HOME_INFO_BEGINS: "PRODUCT/GET_HOME_INFO_BEGINS",
  GET_HOME_INFO_SUCCESS: "PRODUCT/GET_HOME_INFO_SUCCESS",
  GET_HOME_INFO_FAILURE: "PRODUCT/GET_HOME_INFO_FAILURE",
  GET_EXPERTO_INFO_BEGINS: "PRODUCT/GET_EXPERTO_INFO_BEGINS",
  GET_EXPERTO_INFO_SUCCESS: "PRODUCT/GET_EXPERTO_INFO_SUCCESS",
  GET_EXPERTO_INFO_FAILURE: "PRODUCT/GET_EXPERTO_INFO_FAILURE",
  GET_BENEFICIOS_INFO_BEGINS: "PRODUCT/GET_BENEFICIOS_INFO_BEGINS",
  GET_BENEFICIOS_INFO_SUCCESS: "PRODUCT/GET_BENEFICIOS_INFO_SUCCESS",
  GET_BENEFICIOS_INFO_FAILURE: "PRODUCT/GET_BENEFICIOS_INFO_FAILURE",
  GET_DIGITAL_INFO_BEGINS: "PRODUCT/GET_DIGITAL_INFO_BEGINS",
  GET_DIGITAL_INFO_SUCCESS: "PRODUCT/GET_DIGITAL_INFO_SUCCESS",
  GET_DIGITAL_INFO_FAILURE: "PRODUCT/GET_DIGITAL_INFO_FAILURE",
  GET_CONSULTING_INFO_BEGINS: "PRODUCT/GET_CONSULTING_INFO_BEGINS",
  GET_CONSULTING_INFO_SUCCESS: "PRODUCT/GET_CONSULTING_INFO_SUCCESS",
  GET_CONSULTING_INFO_FAILURE: "PRODUCT/GET_CONSULTING_INFO_FAILURE",
  GET_BONOPYME_INFO_BEGINS: "PRODUCT/GET_BONOPYME_INFO_BEGINS",
  GET_BONOPYME_INFO_SUCCESS: "PRODUCT/GET_BONOPYME_INFO_SUCCESS",
  GET_BONOPYME_INFO_FAILURE: "PRODUCT/GET_BONOPYME_INFO_FAILURE",
  GET_AYUDA_INFO_BEGINS: "PRODUCT/GET_AYUDA_INFO_BEGINS",
  GET_AYUDA_INFO_SUCCESS: "PRODUCT/GET_AYUDA_INFO_SUCCESS",
  GET_AYUDA_INFO_FAILURE: "PRODUCT/GET_AYUDA_INFO_FAILURE",
  GET_CONTRATOS_BEGINS: "PRODUCT/GET_CONTRATOS_BEGINS",
  GET_CONTRATOS_SUCCESS: "PRODUCT/GET_CONTRATOS_SUCCESS",
  GET_CONTRATOS_FAILURE: "PRODUCT/GET_CONTRATOS_FAILURE",
};

export const initialState = {
  homeInfo: [],
  expertoInfo: [],
  beneficiosInfo: [],
  digitalInfo: [],
  consultingInfo: [],
  bonoInfo: [],
  ayudaInfo: [],
  contratosInfo: [],
};

const PRODUCT = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_HOME_INFO_BEGINS:
      return {
        ...state,
        homeInfoState: FETCH_STATES.FETCHING,
        id: action.payload,
      };
    case types.GET_HOME_INFO_SUCCESS:
      return {
        ...state,
        homeInfoState: FETCH_STATES.SUCCESS,
        homeInfo: action.payload,
      };
    case types.GET_HOME_INFO_FAILURE:
      return {
        ...state,
        homeInfoState: FETCH_STATES.FAILURE,
      };
    case types.GET_EXPERTO_INFO_BEGINS:
      return {
        ...state,
        expertoInfoState: FETCH_STATES.FETCHING,
        id: action.payload,
      };
    case types.GET_EXPERTO_INFO_SUCCESS:
      return {
        ...state,
        expertoInfoState: FETCH_STATES.SUCCESS,
        expertoInfo: action.payload,
      };
    case types.GET_EXPERTO_INFO_FAILURE:
      return {
        ...state,
        expertoInfoState: FETCH_STATES.FAILURE,
      };
    case types.GET_BENEFICIOS_INFO_BEGINS:
      return {
        ...state,
        beneficiosInfoState: FETCH_STATES.FETCHING,
        id: action.payload,
      };
    case types.GET_BENEFICIOS_INFO_SUCCESS:
      return {
        ...state,
        beneficiosInfoState: FETCH_STATES.SUCCESS,
        beneficiosInfo: action.payload,
      };
    case types.GET_BENEFICIOS_INFO_FAILURE:
      return {
        ...state,
        beneficiosInfoState: FETCH_STATES.FAILURE,
      };
    case types.GET_DIGITAL_INFO_BEGINS:
      return {
        ...state,
        digitalInfoState: FETCH_STATES.FETCHING,
        id: action.payload,
      };
    case types.GET_DIGITAL_INFO_SUCCESS:
      return {
        ...state,
        digitalInfoState: FETCH_STATES.SUCCESS,
        digitalInfo: action.payload,
      };
    case types.GET_DIGITAL_INFO_FAILURE:
      return {
        ...state,
        digitalInfoState: FETCH_STATES.FAILURE,
      };
    case types.GET_CONSULTING_INFO_BEGINS:
      return {
        ...state,
        consultingInfoState: FETCH_STATES.FETCHING,
        id: action.payload,
      };
    case types.GET_CONSULTING_INFO_SUCCESS:
      return {
        ...state,
        consultingInfoState: FETCH_STATES.SUCCESS,
        consultingInfo: action.payload,
      };
    case types.GET_CONSULTING_INFO_FAILURE:
      return {
        ...state,
        consultingInfoState: FETCH_STATES.FAILURE,
      };
    case types.GET_BONOPYME_INFO_BEGINS:
      return {
        ...state,
        bonoInfoState: FETCH_STATES.FETCHING,
        id: action.payload,
      };
    case types.GET_BONOPYME_INFO_SUCCESS:
      return {
        ...state,
        bonoInfoState: FETCH_STATES.SUCCESS,
        bonoInfo: action.payload,
      };
    case types.GET_BONOPYME_INFO_FAILURE:
      return {
        ...state,
        bonoInfoState: FETCH_STATES.FAILURE,
      };
    case types.GET_AYUDA_INFO_BEGINS:
      return {
        ...state,
        ayudaInfoState: FETCH_STATES.FETCHING,
        id: action.payload,
      };
    case types.GET_AYUDA_INFO_SUCCESS:
      return {
        ...state,
        ayudaInfoState: FETCH_STATES.SUCCESS,
        ayudaInfo: action.payload,
      };
    case types.GET_AYUDA_INFO_FAILURE:
      return {
        ...state,
        ayudaInfoState: FETCH_STATES.FAILURE,
      };
    case types.GET_CONTRATOS_BEGINS:
      return {
        ...state,
        contratosInfoState: FETCH_STATES.FETCHING,
        id: action.payload,
      };
    case types.GET_CONTRATOS_SUCCESS:
      return {
        ...state,
        contratosInfoState: FETCH_STATES.SUCCESS,
        contratosInfo: action.payload,
      };
    case types.GET_CONTRATOS_FAILURE:
      return {
        ...state,
        contratosInfoState: FETCH_STATES.FAILURE,
      };
    default:
      return { ...state };
  }
};

export const actions = {
  getHomeInfoBegins: alias => ({
    type: types.GET_HOME_INFO_BEGINS,
    payload: { alias },
  }),
  getHomeInfoSuccess: data => ({
    type: types.GET_HOME_INFO_SUCCESS,
    payload: data,
  }),
  getHomeInfoFailure: () => ({ type: types.GET_HOME_INFO_FAILURE }),
  getExpertoInfoBegins: alias => ({
    type: types.GET_EXPERTO_INFO_BEGINS,
    payload: { alias },
  }),
  getExpertoInfoSuccess: data => ({
    type: types.GET_EXPERTO_INFO_SUCCESS,
    payload: data,
  }),
  getExpertoInfoFailure: () => ({ type: types.GET_EXPERTO_INFO_FAILURE }),
  getBeneficiosInfoBegins: alias => ({
    type: types.GET_BENEFICIOS_INFO_BEGINS,
    payload: { alias },
  }),
  getBeneficiosInfoSuccess: data => ({
    type: types.GET_BENEFICIOS_INFO_SUCCESS,
    payload: data,
  }),
  getBeneficiosInfoFailure: () => ({ type: types.GET_BENEFICIOS_INFO_FAILURE }),
  getDigitalInfoBegins: alias => ({
    type: types.GET_DIGITAL_INFO_BEGINS,
    payload: { alias },
  }),
  getDigitalInfoSuccess: data => ({
    type: types.GET_DIGITAL_INFO_SUCCESS,
    payload: data,
  }),
  getDigitalInfoFailure: () => ({ type: types.GET_DIGITAL_INFO_FAILURE }),
  getConsultingInfoBegins: alias => ({
    type: types.GET_CONSULTING_INFO_BEGINS,
    payload: { alias },
  }),
  getConsultingInfoSuccess: data => ({
    type: types.GET_CONSULTING_INFO_SUCCESS,
    payload: data,
  }),
  getConsultingInfoFailure: () => ({ type: types.GET_CONSULTING_INFO_FAILURE }),
  getBonoInfoBegins: alias => ({
    type: types.GET_BONOPYME_INFO_BEGINS,
    payload: { alias },
  }),
  getBonoInfoSuccess: data => ({
    type: types.GET_BONOPYME_INFO_SUCCESS,
    payload: data,
  }),
  getBonoInfoFailure: () => ({ type: types.GET_BONOPYME_INFO_FAILURE }),
  getAyudaInfoBegins: alias => ({
    type: types.GET_AYUDA_INFO_BEGINS,
    payload: { alias },
  }),
  getAyudaInfoSuccess: data => ({
    type: types.GET_AYUDA_INFO_SUCCESS,
    payload: data,
  }),
  getAyudaInfoFailure: () => ({ type: types.GET_AYUDA_INFO_FAILURE }),
  getContratosInfoBegins: alias => ({
    type: types.GET_CONTRATOS_BEGINS,
    payload: { alias },
  }),
  getContratosInfoSuccess: data => ({
    type: types.GET_CONTRATOS_SUCCESS,
    payload: data,
  }),
  getContratosInfoFailure: () => ({ type: types.GET_CONTRATOS_FAILURE }),
};

export default PRODUCT;
